(function () {
  'use strict';

  var STICKY_CTA_DISMISS_KEY = 'sfStickyCtaDismissed';
  var COPY_FEEDBACK_DURATION = 2000;

  function readSessionFlag(key) {
    try {
      return window.sessionStorage.getItem(key) === '1';
    } catch (error) {
      return false;
    }
  }

  function writeSessionFlag(key) {
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (error) {
      return;
    }
  }

  function copyToClipboard(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function getCopyValue(trigger) {
    var inline = trigger.getAttribute('data-sf-copy');

    if (inline) {
      return inline;
    }

    var targetSelector = trigger.getAttribute('data-sf-copy-target');

    if (!targetSelector) {
      return '';
    }

    var targetEl = document.querySelector(targetSelector);
    return targetEl ? targetEl.textContent.trim() : '';
  }

  function setCopyState(trigger) {
    var defaultText = trigger.getAttribute('data-sf-copy-default-text') || trigger.textContent;
    var successText = trigger.getAttribute('data-sf-copy-success-text') || 'Copiado';
    var feedbackSelector = trigger.getAttribute('data-sf-copy-feedback');
    var feedbackEl = feedbackSelector ? document.querySelector(feedbackSelector) : null;

    if (trigger.sfCopyTimeoutId) {
      window.clearTimeout(trigger.sfCopyTimeoutId);
    }

    trigger.classList.add('sf-copy__btn--copied');
    trigger.setAttribute('aria-label', successText);
    trigger.textContent = successText;

    if (feedbackEl) {
      feedbackEl.textContent = successText;
    }

    trigger.sfCopyTimeoutId = window.setTimeout(function () {
      trigger.classList.remove('sf-copy__btn--copied');
      trigger.removeAttribute('aria-label');
      trigger.textContent = defaultText;

      if (feedbackEl) {
        feedbackEl.textContent = '';
      }
    }, COPY_FEEDBACK_DURATION);
  }

  function handleCopyClick(event) {
    if (!event.target.closest) {
      return;
    }

    var trigger = event.target.closest('[data-sf-copy], [data-sf-copy-target]');

    if (!trigger) {
      return;
    }

    var value = getCopyValue(trigger);

    if (!value) {
      return;
    }

    event.preventDefault();

    copyToClipboard(value)
      .then(function () {
        setCopyState(trigger);
      })
      .catch(function () {
        return;
      });
  }

  function handleStickyCtaDismiss(event) {
    if (!event.target.closest) {
      return;
    }

    var dismissButton = event.target.closest('[data-sf-sticky-cta-dismiss]');

    if (!dismissButton) {
      return;
    }

    var stickyEl = dismissButton.closest('[data-sf-sticky-cta]');

    if (stickyEl) {
      stickyEl.hidden = true;
    }

    writeSessionFlag(STICKY_CTA_DISMISS_KEY);
  }

  function syncStickyCta(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var stickyEls = Array.prototype.slice.call(root.querySelectorAll('[data-sf-sticky-cta]'));

    if (root.matches && root.matches('[data-sf-sticky-cta]')) {
      stickyEls.push(root);
    }

    var dismissed = readSessionFlag(STICKY_CTA_DISMISS_KEY);

    stickyEls.forEach(function (el) {
      var enabled = el.getAttribute('data-sf-sticky-cta') !== 'disabled';
      el.hidden = !enabled || dismissed;
    });
  }

  function init(scope) {
    syncStickyCta(scope);
  }

  document.addEventListener('click', handleCopyClick);
  document.addEventListener('click', handleStickyCtaDismiss);

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
